module.exports = __webpack_public_path__ + "static/media/circleBased.953e87ef.svg";